import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {mapUserDataResponseToUser} from '../api-helpers/map-user-data-response-to-user.util';
import {HttpClient} from '@angular/common/http';
import {TISA_WICKET_URL, TISA_WICKET_V2_API_URL} from '../tisa-wicket.providers';
import {WicketUser} from '@tisa-group/models';
import {WicketUserDataSection} from '@tisa-group/models/wicket/wicket-user-data-section/wicket-user-data-section';

@Injectable({
  providedIn: 'root',
})
export class WicketUserDataService {
  constructor(
    protected readonly httpClient: HttpClient,
    @Inject(TISA_WICKET_V2_API_URL) readonly providedWicketV2Url: string | (() => string),
  ) {}

  getUserData(): Observable<WicketUser> {
    return this.httpClient.get<WicketUser>(`${this.wicketV2Url}/data/user`).pipe(
      map(response => {
        const user = mapUserDataResponseToUser(response);

        return user;
      }),
    );
  }

  getUserDataSections(applicationSub: string): Observable<WicketUserDataSection[]> {
    return this.httpClient.get<WicketUserDataSection[]>(
      `${this.wicketV2Url}/data/types/group?application_id=${applicationSub}`,
    );
  }

  get wicketV2Url() {
    return this.providedWicketV2Url instanceof Function
      ? this.providedWicketV2Url()
      : this.providedWicketV2Url;
  }
}
